import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'influencerAudiences',
  urlRoot: '/influencer_audiences'
})
